import auth from './auth.json';
import dashboard from './dashboard.json';
import global from './global.json';
import integrations from './integrations.json';
import profile from './profile.json';
import subscriptions from './subscriptions.json';

export default {
  ...global,
  ...auth,
  ...dashboard,
  ...profile,
  ...subscriptions,
  ...integrations,
};
